/* Napuplant — control de cantidades del cajón del carrito.

   EL PROBLEMA QUE RESUELVE

   Pulsar «+» una vez disparaba hasta cuatro escrituras al carrito y tres
   repintados: cart.js de Paris cambiaba la cantidad y repintaba, napu-cart-sync
   repintaba otra vez, eso despertaba a napu-care.js, que borraba la línea de la
   garantía y añadía otra con el tramo nuevo, y cada una de esas dos volvía a
   repintar. Pulsando deprisa se apilaban capas de carga, se perdían acciones y
   el carrito acababa en estados imposibles: plantas que resucitaban y una
   garantía cobrándose sobre un carrito vacío.

   Y había un fallo de fondo, en Paris: cart.js manda a /cart/change un `line`,
   que es un ÍNDICE DE POSICIÓN. Cuando una línea llega a cero y desaparece,
   todos los índices de abajo se desplazan, así que una petición en vuelo para
   «la línea 2» acaba modificando otro producto.

   CÓMO SE RESUELVE

   1. El número se pinta AL INSTANTE, sin esperar al servidor. Es lo que quita la
      sensación de lentitud: la petición va detrás, sin que se note.
   2. Las pulsaciones se AGRUPAN. Cinco toques al «+» son una sola petición con
      la cantidad final, no cinco.
   3. Se usa /cart/update.js con la CLAVE DE LÍNEA (item.key), no el índice. La
      clave no se mueve aunque desaparezcan otras líneas, así que se modifica
      siempre lo que se pretendía. Además update.js acepta varias líneas de una
      vez, así que tocar tres productos es una petición, no tres.
   4. El tramo de Care+ se calcula AQUÍ, antes de enviar, y viaja en el mismo
      lote. Se acabó la segunda carga que aparecía después de cada clic.
   5. Se repinta UNA vez, al final.

   Convive con Paris: se interceptan los clics en fase de captura y se detiene su
   propagación, así que los manejadores de cart.js no llegan a ejecutarse. No se
   ha modificado cart.js.
*/
(function () {
  'use strict';

  var ESPERA = 350;        // ms de agrupación tras la última pulsación
  var MAX_QTY = 99;

  var objetivo = {};       // clave de línea -> cantidad deseada
  var timer = null;
  var aplicando = false;
  var otraRonda = false;

  function raiz() { return document.getElementById('minicart'); }

  function lineaDe(el) {
    return el && el.closest ? el.closest('[data-napu-key]') : null;
  }

  /* Cantidad que debe mostrar una línea: la deseada si la hemos tocado, y si no
     la que vino pintada del servidor.

     `mapa` se pasa explícitamente al calcular la base de Care+ porque para
     entonces `objetivo` ya se ha vaciado (se copia a `cambios` al empezar el
     lote). Sin este parámetro el tramo se calculaba con las cantidades ANTERIORES
     y llegaba siempre un paso por detrás. */
  function cantidadDe(linea, mapa) {
    var m = mapa || objetivo;
    var k = linea.getAttribute('data-napu-key');
    if (Object.prototype.hasOwnProperty.call(m, k)) return m[k];
    return parseInt(linea.getAttribute('data-napu-qty'), 10) || 0;
  }

  function pintarCantidad(linea, n) {
    var campo = linea.querySelector('input[name="updates[]"], .cart-product-qty input');
    if (campo) { campo.value = n; campo.setAttribute('value', n); }
  }

  /* Base del 7% de Care+: solo los tipos cubiertos, y nunca la propia garantía.
     Se calcula con los datos que Liquid dejó en el marcado y con las cantidades
     que ESTAMOS A PUNTO de aplicar, no con las que hay ahora. Por eso el tramo
     sale correcto a la primera y no hace falta una segunda vuelta. */
  function baseCentimos(mapa) {
    var total = 0;
    var care = window.napuCare;
    document.querySelectorAll('#minicart [data-napu-key]').forEach(function (linea) {
      var tipo = (linea.getAttribute('data-napu-type') || '').toLowerCase().trim();
      if (!care || !care.cubierto({ product_type: tipo })) return;
      var unidad = parseInt(linea.getAttribute('data-napu-unit'), 10) || 0;
      total += unidad * cantidadDe(linea, mapa);
    });
    return Math.max(0, total);
  }

  function lineaCare() {
    var care = window.napuCare;
    if (!care) return null;
    var encontrada = null;
    document.querySelectorAll('#minicart [data-napu-key]').forEach(function (linea) {
      if (linea.getAttribute('data-napu-handle') === care.HANDLE) encontrada = linea;
    });
    return encontrada;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function aplicar() {
    if (aplicando) { otraRonda = true; return; }
    var cambios = objetivo;
    objetivo = {};
    if (!Object.keys(cambios).length) return;

    aplicando = true;
    var care = window.napuCare;
    var sync = window.napuCart;

    /* Silencio: durante el lote, ni napu-cart-sync repinta por cada escritura ni
       napu-care lanza las suyas. Repintamos nosotros una sola vez al final. */
    if (sync) sync.silencio = true;
    if (care) care.pausado = true;

    /* ¿Qué debe pasar con la garantía? Se decide ANTES de enviar, con las
       cantidades nuevas ya contadas. */
    var care_l = lineaCare();
    var claveCare = care_l ? care_l.getAttribute('data-napu-key') : null;
    var tramo = null;
    var quiereCare = !!care_l;
    if (quiereCare && care && care.hayTramos()) {
      var base = baseCentimos(cambios);
      /* Sin plantas cubiertas la garantía se retira sola: no habría nada que
         garantizar, y dejarla es exactamente el cobro fantasma que se reportó. */
      tramo = base > 0 ? care.tramoPara(base) : null;
    }

    /* Un solo update con todas las líneas. Si el tramo de la garantía cambia, su
       línea vieja entra en el mismo lote con cantidad 0 y la nueva se añade
       después: dos peticiones como mucho, y un único repintado. */
    var updates = {};
    Object.keys(cambios).forEach(function (k) { updates[k] = cambios[k]; });

    var hayQueAnadirTramo = false;
    if (claveCare) {
      if (!tramo) {
        updates[claveCare] = 0;
      } else {
        var idActual = parseInt(care_l.getAttribute('data-napu-variant'), 10);
        if (idActual !== tramo.id) {
          updates[claveCare] = 0;
          hayQueAnadirTramo = true;
        }
      }
    }

    postJSON('/cart/update.js', { updates: updates })
      .then(function () {
        if (hayQueAnadirTramo && tramo) {
          return postJSON('/cart/add.js', { items: [{ id: tramo.id, quantity: 1 }] });
        }
      })
      .catch(function () { /* si falla, el repintado devuelve la verdad */ })
      .then(function () {
        if (sync) sync.silencio = false;
        if (care) care.pausado = false;
        return sync && sync.repintar ? sync.repintar() : null;
      })
      .then(function () {
        aplicando = false;
        if (otraRonda) { otraRonda = false; programar(0); }
      });
  }

  function programar(ms) {
    clearTimeout(timer);
    timer = setTimeout(aplicar, typeof ms === 'number' ? ms : ESPERA);
  }

  function ajustar(linea, nueva) {
    var k = linea.getAttribute('data-napu-key');
    if (!k) return;
    nueva = Math.max(0, Math.min(MAX_QTY, nueva));
    objetivo[k] = nueva;

    if (nueva === 0) {
      /* Se atenúa en lugar de borrarse del DOM: quitarla ya movería la lista
         antes de que el servidor confirme, y si la petición fallara habría que
         devolverla a su sitio. Al repintar desaparece de verdad. */
      linea.style.opacity = '.4';
      linea.style.pointerEvents = 'none';
    } else {
      pintarCantidad(linea, nueva);
    }
    programar();
  }

  /* Captura: se adelanta a los manejadores de cart.js y los deja sin efecto. */
  document.addEventListener('click', function (e) {
    var host = raiz();
    if (!host || !host.contains(e.target)) return;

    var boton = e.target.closest ? e.target.closest('.qunt-btn, cart-remove-item-button, .cart-remove-item') : null;
    if (!boton) return;

    var linea = lineaDe(boton);
    if (!linea) return;   // sin clave no intervenimos: que actúe Paris

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (boton.classList.contains('qunt-btn')) {
      var suma = boton.classList.contains('qunt-plus') || boton.getAttribute('name') === 'plus' ? 1 : -1;
      ajustar(linea, cantidadDe(linea) + suma);
    } else {
      ajustar(linea, 0);
    }
  }, true);

  /* Escribir la cantidad a mano en el campo. */
  document.addEventListener('change', function (e) {
    var host = raiz();
    if (!host || !host.contains(e.target)) return;
    if (!e.target.matches || !e.target.matches('input[name="updates[]"]')) return;
    var linea = lineaDe(e.target);
    if (!linea) return;
    e.stopPropagation();
    e.stopImmediatePropagation();
    ajustar(linea, parseInt(e.target.value, 10) || 0);
  }, true);
})();
